import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_ADMIN_TAXONOMIES_VERSIONS_QUERY_KEY } from './useGetAdminTaxonomyVersions';

import TaxonomiesService, {
  CreateCompleteVersionDto,
} from '@/services/TaxonomiesService';

export function useCreateTaxonomyVersion(customerId: number) {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (createCompleteVersion: CreateCompleteVersionDto) =>
      TaxonomiesService.createAdminTaxonomy(customerId, createCompleteVersion),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_ADMIN_TAXONOMIES_VERSIONS_QUERY_KEY(customerId),
      });
    },
  });

  return {
    createTaxonomy: mutateAsync,
    isPending,
  };
}
